'use client';

import { useEffect, useRef } from 'react';

/**
 * Component to ensure the HTML lang attribute is always synchronized with the current locale
 */
export function HtmlLangSync({ locale }: { locale: string }) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!locale) return;

    const targetLang = locale.toLowerCase();
    const currentLang = document.documentElement.getAttribute('lang');

    // On first render, only update if different (avoid flash)
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if (currentLang === targetLang) {
        // Already correct, don't update
        return;
      }
      // Update if different
      document.documentElement.setAttribute('lang', targetLang);
      return;
    }

    // On subsequent renders (locale changes), always update
    if (currentLang !== targetLang) {
      document.documentElement.setAttribute('lang', targetLang);
    }
  }, [locale]);

  return null;
}
